module.exports = __webpack_public_path__ + "static/media/france.6959066c.svg";